import { useContext } from 'react'

import {
  FeatureFlagsContextType,
  FeatureFlagsContextTypeInitialized,
  FeatureKeyValueMap,
} from '../types'
import { FeatureFlagsContext } from './feature-flags-context'

export function useFeatureFlags<
  F extends FeatureKeyValueMap
>(): FeatureFlagsContextTypeInitialized<F> {
  const context = useContext<FeatureFlagsContextType<F>>(FeatureFlagsContext)
  if (!context.initialized) {
    throw new Error(
      '[shared-feature-flags] called useFeatureFlags without FeatureFlagsProvider as a parent node'
    )
  }
  return context
}
